import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
const hostname = window.location.origin;

const KINDE_CONFIG = {
    clientId: 'bd2ddbb664934f3185a4723d92e53f14',
    domain: 'https://auth.gnibox.com',
    logoutUri: `${hostname}/welcome`,
    redirectUri: `${hostname}/callback`,
};

root.render(
    <React.StrictMode>
        <KindeProvider {...KINDE_CONFIG}>
            <App />
        </KindeProvider>
    </React.StrictMode>
);

reportWebVitals();
